import React from 'react';

const InvalidAction = props => {
  return (
    <div className="activation-page">
      <div className="activation-content">
        <div className="form-content">
          <h3>{props.title}</h3>
          <p>{props.description}</p>
        </div>
        <div className="form-action"></div>
      </div>
    </div>
  );
};

export default InvalidAction;
